import tw from "tailwind-styled-components";

export const Heading3 = tw("h3")`text-lg font-normal text-gray-800`;

export const Heading4 = tw("h4")`text-sm font-normal text-gray-500 uppercase`;
